/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface INetworkElement {
        name: string;
        href: string;
        networkInterfaces: INetworkInterface[];
        defaultGatewayId: number;
        isConnectedToNetwork: () => boolean;
        getAvailableInterfaces: () => INetworkInterface[];
    }

    export class NetworkElement implements INetworkElement {
        public name: string;
        public href: string;
        public networkInterfaces: INetworkInterface[];
        public defaultGatewayId: number;

        public static Empty(): NetworkElement {
            return new NetworkElement();
        }

        constructor() {
            this.name = '';
            this.href = '';
            this.networkInterfaces = [];
        }

        public getAvailableInterfaces(): INetworkInterface[] {
            return this.networkInterfaces.filter (
                (nic: INetworkInterface) => {
                    /* tslint:disable */return nic.networkConnectedTo === null;/* tslint:enable */
                }
            );
        }
        
         public isConnectedToNetwork(): boolean {
            return this.networkInterfaces.some (
                (nic: INetworkInterface) => {
                    /* tslint:disable */
                    return nic !== undefined &&
                        nic.networkConnectedTo !== undefined && nic.networkConnectedTo !== null;
                    /* tslint:enable */
                }
            );
        }
    }
}